import React, { useCallback, useEffect, useRef, useState } from "react";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import DateComponent from "../../../commoncomponents/input/DateComponent";
import { getDatefromSqlDate } from "../../../../util/GenralUtils";
import { getRequest, singoutHandler } from "../../../../api/AxiosAPICall";
import {
  Box,
  CircularProgress,
  Typography,
  Grid,
  Tooltip,
} from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { ErrorMessage, FieldArray, FormikProvider, getIn } from "formik";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { nanoid } from "nanoid";

const ClinicianAwards = ({
  formik,
  sendAwardEeaId,
  sendAwardsDetails,
  loader,
  sendCloseSnackbar,
}: {
  formik: any;
  sendAwardEeaId: any;
  sendAwardsDetails: any;
  loader: any;
  sendCloseSnackbar: any;
}) => {
  const [open, setOpen] = useState(false);
  const isMounted = useRef<any>(false);
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const dispatch = useDispatch();
  let history = useNavigate();
  const fetchestablishmentProfessionalJson = useCallback(async () => {
    setOpen(true);
    const response = await getRequest(
      "establishmentProfessionals/awardDetails",
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      if (
        response?.data?.additionalDetails?.awards !== undefined &&
        response?.data?.additionalDetails?.awards !== null &&
        response?.data?.additionalDetails?.awards !== ""
      ) {
        sendAwardsDetails(response.data.additionalDetails.awards);
        response.data.additionalDetails.awards.forEach(
          (element: any, index: any) => {
            formik.setFieldValue(`awards[${index}].eeaId`, element.eeaId);
            formik.setFieldValue(
              `awards[${index}].collegeawards`,
              element.eeaInstituteName
            );
            if (
              element.eeaDate !== undefined &&
              element.eeaDate !== null &&
              element.eeaDate !== "" &&
              moment(element.eeaDate).isValid() !== false
            ) {
              formik.setFieldValue(
                `awards[${index}].awardsDate`,
                getDatefromSqlDate(element.eeaDate)
              );
            } else {
              formik.setFieldValue(`awards[${index}].awardsDate`, null);
            }
          }
        );
      }
    }
    setOpen(false);
    sendCloseSnackbar("awardSnackbar");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    isMounted.current = true;

    jwtToken && fetchestablishmentProfessionalJson();
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line
  }, [loader]);

  return (
    <CommonCard>
      <Typography variant="h6" className={globalClasses.typography}>
        Awards
      </Typography>
      {open && (
        <Box className={globalClasses.loader}>
          <CircularProgress color="primary" />
        </Box>
      )}
      {!open && (
        <FormikProvider value={formik}>
          <FieldArray
            name="awards"
            render={(arrayHelpers) => (
              <Box sx={{ width: "100% !important" }}>
                {formik.values.awards.map((awards: any, index: any) => (
                  <Box key={awards.id} sx={{ width: "100%" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <input
                          type="hidden"
                          id={`awards[${index}].eeaId`}
                          name={`awards[${index}].eeaId`}
                          value={formik.values.awards[index].eeaId ?? ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <InputField
                          id={`awards[${index}].collegeawards`}
                          name={`awards[${index}].collegeawards`}
                          label=" Award Name"
                          inputvalues={
                            formik.values.awards[index].collegeawards
                          }
                          changeevent={formik.handleChange}
                          blurevent={formik.handleBlur}
                        />

                        <ErrorMessage name={`awards.${index}.collegeawards`} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <DateComponent
                          label="Award Date"
                          value={formik.values.awards[index].awardsDate}
                          onChange={(newValue: Date | null) => {
                            formik.setFieldValue(
                              `awards[${index}].awardsDate`,
                              newValue
                            );
                            console.log(formik.errors, "formik.errors");
                          }}
                          inputId={`awards[${index}].awardsDate`}
                          inputName={`awards[${index}].awardsDate`}
                          inputValue={formik.values.awards[index].awardsDate}
                          error={
                            getIn(
                              formik.touched,
                              `awards[${index}].awardsDate`
                            ) &&
                            getIn(formik.errors, `awards[${index}].awardsDate`)
                          }
                          helperText={
                            getIn(
                              formik.touched,
                              `awards[${index}].awardsDate`
                            ) &&
                            getIn(
                              formik.errors,
                              `awards[${index}].awardsDate`
                            ) && (
                              <ErrorMessage
                                name={`awards[${index}].awardsDate`}
                              />
                            )
                          }
                          inputOnBlur={formik.handleBlur}
                          inputOnChange={(newValue: Date | null) => {
                            formik.setFieldValue(
                              `awards[${index}].awardsDate`,
                              newValue
                            );
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Tooltip title="Delete">
                        <DeleteForeverOutlinedIcon
                          className={globalClasses.deleteIcon}
                          color="error"
                          sx={{ float: "right" }}
                          onClick={() => {
                            sendAwardEeaId(
                              arrayHelpers.form.values.awards[index].eeaId
                            );
                            arrayHelpers.form.values.awards.length !== 1
                              ? arrayHelpers.remove(index)
                              : arrayHelpers.remove(1);
                          }}
                        />
                      </Tooltip>
                    </Grid>
                  </Box>
                ))}
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{
                    marginTop: "40px !important",
                    padding: "10px",
                  }}
                >
                  <ButtonComponent
                    buttonclass={globalClasses.addButton}
                    variant="contained"
                    size="small"
                    label="Add"
                    onClick={() =>
                      arrayHelpers.push({
                        id: nanoid(),
                        eeaId: "new",
                        collegeawards: "",
                        awardsDate: "",
                      })
                    }
                  />
                </Grid>
              </Box>
            )}
          />
        </FormikProvider>
      )}
    </CommonCard>
  );
};

export default ClinicianAwards;
